export default function TechBar() {
  return (
    <section id="techbar" className="bg-white py-16 md:py-28 lg:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <p className="text-[#D4AF37] text-xs uppercase tracking-[0.4em] mb-4 font-light">
            Inovação & Exclusividade
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-black mb-6 tracking-wide">
            TechBar
          </h2>
          <div className="w-16 h-px bg-[#D4AF37] mx-auto mb-6"></div>
          <p className="text-[#555555] text-sm font-light tracking-wide max-w-xl mx-auto leading-relaxed">
            A máquina de autoatendimento de drinks que une tecnologia, experiência e exclusividade nos seus eventos.
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-16 md:mb-24">

          {/* Image */}
          <div className="relative">
            <div className="absolute -inset-4 bg-[#D4AF37]/5 rounded-none"></div>
            <div className="relative border border-[#D4AF37]/30 overflow-hidden">
              <img
                src="https://static.readdy.ai/image/7ce29a8f289d24a52677c0daf40c6c66/8aff88ba28b9ebe289594f28689bb1b8.jpeg"
                alt="TechBar - Máquina de autoatendimento de drinks"
                className="w-full h-[420px] md:h-[520px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse"></div>
                  <span className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light">Tecnologia em operação</span>
                </div>
              </div>
            </div>
          </div>

          {/* Text Content */}
          <div className="space-y-8">
            <div>
              <h3 className="font-serif text-2xl md:text-3xl font-light text-black mb-4 leading-snug">
                Máquina de autoatendimento de drinks
              </h3>
              <p className="text-[#555555] text-sm font-light leading-relaxed mb-4">
                A TechBar nasceu como uma solução que une o melhor da tecnologia, experiência e drinks.{' '}
                <strong className="text-black font-medium">A escolha definitiva para quem busca transcender expectativas.</strong>
              </p>
              <p className="text-[#555555] text-sm font-light leading-relaxed">
                A máquina fornece dados precisos de consumo, evita desperdícios e traz consistência ao longo de toda operação com{' '}
                <strong className="text-black font-medium">uma praticidade que somente a tecnologia pode oferecer.</strong>
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="border border-[#E0D0A0] p-6 text-center hover:border-[#D4AF37] transition-colors duration-300">
                <p className="text-[#D4AF37] text-4xl font-light font-serif mb-2">15+</p>
                <p className="text-[#555555] text-xs uppercase tracking-[0.2em] font-light leading-relaxed">Tipos de drinks preparados</p>
              </div>
              <div className="border border-[#E0D0A0] p-6 text-center hover:border-[#D4AF37] transition-colors duration-300">
                <p className="text-[#D4AF37] text-4xl font-light font-serif mb-2">6s</p>
                <p className="text-[#555555] text-xs uppercase tracking-[0.2em] font-light leading-relaxed">Para preparar cada drink</p>
              </div>
            </div>

            {/* How it works */}
            <div className="border-l-2 border-[#D4AF37] pl-6 space-y-4">
              <p className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light mb-4">Como funciona</p>
              <div className="flex items-start gap-4">
                <span className="w-6 h-6 flex items-center justify-center border border-[#D4AF37]/40 text-[#D4AF37] text-xs font-light shrink-0 mt-0.5">1</span>
                <p className="text-[#444444] text-sm font-light leading-relaxed">O convidado escolhe o drink na interface touchscreen da TechBar</p>
              </div>
              <div className="flex items-start gap-4">
                <span className="w-6 h-6 flex items-center justify-center border border-[#D4AF37]/40 text-[#D4AF37] text-xs font-light shrink-0 mt-0.5">2</span>
                <p className="text-[#444444] text-sm font-light leading-relaxed">O copo é posicionado na saída da máquina</p>
              </div>
              <div className="flex items-start gap-4">
                <span className="w-6 h-6 flex items-center justify-center border border-[#D4AF37]/40 text-[#D4AF37] text-xs font-light shrink-0 mt-0.5">3</span>
                <p className="text-[#444444] text-sm font-light leading-relaxed">O drink fica pronto em <strong className="text-[#D4AF37]">cerca de 6 segundos</strong></p>
              </div>
            </div>
          </div>
        </div>

        {/* Features Row */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-[#FAFAFA] border border-[#E0D0A0] p-8 text-center hover:border-[#D4AF37] transition-all duration-300 group">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-5 border border-[#E0D0A0] group-hover:border-[#D4AF37] transition-colors duration-300">
              <i className="ri-cpu-line text-[#D4AF37] text-2xl"></i>
            </div>
            <h4 className="text-black text-sm uppercase tracking-widest font-light mb-3">Tecnologia</h4>
            <p className="text-[#666666] text-xs font-light leading-relaxed">
              Interface touchscreen intuitiva com dados precisos de consumo em tempo real
            </p>
          </div>
          <div className="bg-[#FAFAFA] border border-[#E0D0A0] p-8 text-center hover:border-[#D4AF37] transition-all duration-300 group">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-5 border border-[#E0D0A0] group-hover:border-[#D4AF37] transition-colors duration-300">
              <i className="ri-vip-crown-line text-[#D4AF37] text-2xl"></i>
            </div>
            <h4 className="text-black text-sm uppercase tracking-widest font-light mb-3">Exclusividade</h4>
            <p className="text-[#666666] text-xs font-light leading-relaxed">
              Experiência única e sofisticada que eleva o nível de qualquer evento
            </p>
          </div>
          <div className="bg-[#FAFAFA] border border-[#E0D0A0] p-8 text-center hover:border-[#D4AF37] transition-all duration-300 group">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-5 border border-[#E0D0A0] group-hover:border-[#D4AF37] transition-colors duration-300">
              <i className="ri-bar-chart-line text-[#D4AF37] text-2xl"></i>
            </div>
            <h4 className="text-black text-sm uppercase tracking-widest font-light mb-3">Eficiência</h4>
            <p className="text-[#666666] text-xs font-light leading-relaxed">
              Zero desperdício, consistência total e agilidade incomparável no serviço
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-14 md:mt-20 text-center">
          <p className="text-[#666666] text-sm font-light mb-6">
            Leve a TechBar para o seu próximo evento
          </p>
          <a
            href="https://wa.me/5562985101348?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20proposta%20para%20a%20TechBar!"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-3 border border-[#D4AF37] text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light px-10 py-4 hover:bg-[#D4AF37] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-sm"></i>
            Solicitar Proposta
          </a>
        </div>

      </div>
    </section>
  );
}
